import { websitesActionsService } from "../../../services/api/websites-actions.endpoints";
import store from "../../../store";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { setFinanceList } from "../../../features/websiteActionSlice";
import GenericEndPointsLogic from "../../GenericEndPointsLogic/GenericEndPointsLogic";

async function getAllWebsites(oauthTokenHeader: string, setWebsiteList: any) {
  try {
    const response =
      await websitesActionsService.getAllWebsiteList(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setWebsiteList(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function getMetaRegions(oauthTokenHeader: string, setRegionsList: any) {
  try {
    const response =
      await websitesActionsService.getMetaRegions(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get regions list");
    } else {
      setRegionsList(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function postWebsite(
  oauthTokenHeader: string,
  data: any,
  setShowCongratulationModal: any,
) {
  try {
    const response = await websitesActionsService.postWebsite(
      oauthTokenHeader,
      data,
    );
    if (!response || !response.status || response.status !== 200) {
      setShowCongratulationModal(false);
      throw new Error("Failed to create website");
    } else {
      setShowCongratulationModal(true);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

const requestANewDomainIntegration = async (
  oauthTokenHeader: any,
  setRequest: any,
  data: any,
) => {
  try {
    const response = await websitesActionsService.requestDomainIntegration(
      oauthTokenHeader,
      data,
    );
    if (!response.status || response.status !== 201) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Creating a new theme",
          type: "error",
        }),
      );
    } else {
      setRequest(response?.data);
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Domain Integration Request Sent Successfully",
          type: "success",
        }),
      );
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
};

const getDomainRequestsData = async (
  oauthTokenHeader: any,
  setDomainRequestsData: any,
) => {
  try {
    const response =
      await websitesActionsService.getDomainRequests(oauthTokenHeader);
    if (!response?.status || ![200, 204].includes(response.status)) {
      throw new Error("Failed to get Domain Requests");
    } else {
      setDomainRequestsData(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    // store.dispatch(
    //   setDisplayErrorSnackBar({
    //     message: e?.parsedText || "Unknown error occurred",
    //     type: "error",
    //   })
    // );
  }
};

async function getWebsitesSettingData(
  oauthTokenHeader: string,
  setSettingsAttributes: any,
  selectedWebsiteShareuid: any,
  navigate: any,
  searchParams: URLSearchParams,
) {
  try {
    const response = await websitesActionsService.getSettingAttributes(
      oauthTokenHeader,
      selectedWebsiteShareuid,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get Website Setting Attributes");
    } else {
      setSettingsAttributes(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
    navigate(`/operations/website_actions?${searchParams.toString()}`);
  }
}

async function updateWebsitesSettingData(
  data: any,
  selectedWebsiteShareuid: any,
  oauthTokenHeader: string,
) {
  try {
    const response = await websitesActionsService.updateSettingsData(
      data,
      selectedWebsiteShareuid,
      oauthTokenHeader,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get Website Setting Attributes");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Website settings have been updated successfully",
          type: "success",
        }),
      );
      // Sync variants for the website whose settings changed (non-blocking)
      GenericEndPointsLogic.updateVariants({
        oauthTokenHeader,
        websiteSharedUid: selectedWebsiteShareuid,
        entityType: "website",
        entitySharedUid: selectedWebsiteShareuid,
      });
      return response?.data?.reason;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function updateEditWebsitesData(
  data: any,
  selectedWebsiteShareuid: any,
  oauthTokenHeader: string,
) {
  try {
    const response = await websitesActionsService.updateEditSettingsData(
      data,
      selectedWebsiteShareuid,
      oauthTokenHeader,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update Website data");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "The website data has been successfully updated.",
          type: "success",
        }),
      );
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function deactiveOrReactivateWebsite(
  data: any,
  selectedWebsiteShareuid: any,
  oauthTokenHeader: string,
) {
  try {
    const response = await websitesActionsService.deactiveOrReactivate(
      data,
      selectedWebsiteShareuid,
      oauthTokenHeader,
    );
    if (!response?.status || ![200, 204].includes(response.status)) {
      throw new Error("Failed to Deactive Or Reactivate Website data");
    } else {
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

async function syncEnableOrDisable(
  data: any,
  selectedWebsiteShareuid: any,
  oauthTokenHeader: string,
) {
  try {
    const response = await websitesActionsService.isSyncEnable(
      data,
      selectedWebsiteShareuid,
      oauthTokenHeader,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update website sync data");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Sync has been successfully updated.",
          type: "success",
        }),
      );
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
    return e ? e?.parsedText : { reason: "Unknown error occurred" };
  }
}

async function updateWebsiteURL(
  data: any,
  selectedWebsiteShareuid: any,
  oauthTokenHeader: string,
) {
  try {
    const response = await websitesActionsService.updateWebsiteURL(
      data,
      selectedWebsiteShareuid,
      oauthTokenHeader,
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update website URL data");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Website URL has been successfully updated.",
          type: "success",
        }),
      );
      return response;
    }
  } catch (e: any) {
    let errorMessage = "Unknown error occurred";

    try {
      if (e?.text) {
        const parsed = JSON.parse(e.text);
        if (parsed?.reason) {
          errorMessage = parsed.reason;
        }
      } else if (e?.message) {
        errorMessage = e.message;
      }
    } catch (parseError) {
      console.error("Error parsing error response:", parseError);
    }

    store.dispatch(
      setDisplayErrorSnackBar({
        message: errorMessage,
        type: "error",
      }),
    );
  }
}

async function fetchFinanceList(oauthTokenHeader: any) {
  try {
    const response =
      await websitesActionsService.fetchFinanceList(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      store.dispatch(setFinanceList(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  }
}

export const websiteActionEndPointLogic = {
  getAllWebsites,
  getWebsitesSettingData,
  updateWebsitesSettingData,
  updateEditWebsitesData,
  syncEnableOrDisable,
  deactiveOrReactivateWebsite,
  getMetaRegions,
  postWebsite,
  requestANewDomainIntegration,
  getDomainRequestsData,
  updateWebsiteURL,
  fetchFinanceList,
};
